import { useCallback } from 'react';
import { platformService } from '../../services/platform.service';
import { useSetState } from '../../../AppState';
import { reportFailure } from './inlineCell';
import type { TagRecord } from './InlineTagsCell';
import { findOrCreateTag, withTag } from './tagCreation';

/**
 * "New tag 'name'" in any Tags box (list cell, Edit / New Ticket, Bulk Edit, templates): a name already in use is
 * not made twice, and the tag joins the app's tag list - which the list's Tags cells offer and name their chips from.
 * Null when it failed, after saying so.
 */
export const useCreateTag = () => {
  const setAppState = useSetState();

  return useCallback(async (name: string): Promise<TagRecord | null> => {
    try {
      const tag = await findOrCreateTag(new platformService(), name);
      setAppState(prev => {
        const tags = withTag(prev.tags, tag);
        return tags === prev.tags ? prev : { ...prev, tags };
      });
      return tag;
    } catch (error: unknown) {
      reportFailure(error);
      return null;
    }
  }, [setAppState]);
};
